/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {injectIntl, FormattedMessage, FormattedHTMLMessage} from "react-intl";
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'
import {InputLabel, Button, Grid, Notification, Select} from '@scuf/common';
import Loader from '../common/Loader'
import * as Assets from "../api/Assets";
import * as Fleets from "../api/Fleets";
import queryString from 'query-string'
import {SYMPTOM_STATES, SYMPTOM_TYPES, FAULT_STATES} from './common/FaultsConst'
import {getFaultName, verifyAirtimeException} from "../utils/Helpers";
import AssetTreeSelector from './AssetTreeSelector'
import * as FaultActions from '../faults/FaultActions'
import * as SecurityActions from '../security/SecurityActions'
import {bindActionCreators} from "redux";
import {userHasActivity} from "../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../security/SecurityConst";
import engineHTF7K from "../styling/images/AS907.png";
import engineTFE731 from "../styling/images/TFE731.png";
import * as Airtime from "../api/Airtime"
import {getUIconfigs, UIconfigNames} from "../api/UIconfig";
import DisclaimerWindow from "../about/DisclaimerWindow";
import {ASSETS_DATA_SET_TYPE} from "../admin/assets/AssetsConst";
import {showNotification} from "../common/ToastNotification";

class FaultReport extends React.Component {
    constructor(props) {
        super(props);

        this.state = this.initState;

        this.loadObservations = this.loadObservations.bind(this)
        this.addObservation = this.addObservation.bind(this)
        this.submitReport = this.submitReport.bind(this)
        this.resetReport = this.resetReport.bind(this)
        this.fetchAssets = this.fetchAssets.bind(this)
        this.assetCreated = this.assetCreated.bind(this)

        const {intl} = this.props;

        this.alreadyAssigned = " - (" + intl.formatMessage({id:"fault.report.symptomAssigned"}) + ")";
    }

    initState = {
        hierarchy: [],
        selectedAssetId: null,
        selectedObservations: null,
        disableSubmit: true,
        submitSuccessful: false,
        observations: [],
        symptomsOfInterest: [],
        affectedFaults: [],
        loading: false,
        ldiName: '',
        apiPoint: userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY) ? Airtime : Assets,
        UIconfig_ALLOW_JUST_ONE_SYMPTOM_TO_REPORT: false,
        UIconfig_JUMP_DIRECTLY_TO_OBSERVATIONS: false,
        UIconfig_SHOW_NEW_FAULT_DISCLAIMER: false,

        submittedAutomatically: false,
        failureModeIdentified: null,
    }

    componentDidMount() {
        this.setState({loading: true})
        const query = queryString.parse(this.props.location.search)
        let assetId;
        if (query.assetId && !isNaN(Number.parseInt(query.assetId, 10))) {
            assetId = Number.parseInt(query.assetId, 10)
        }
        this.fetchAssets(assetId)
        getUIconfigs([UIconfigNames.ALLOW_JUST_ONE_SYMPTOM_TO_REPORT, UIconfigNames.JUMP_DIRECTLY_TO_OBSERVATIONS, UIconfigNames.SHOW_NEW_FAULT_DISCLAIMER]).then((response) => {
            const allowOne = response.filter(c => c.name === UIconfigNames.ALLOW_JUST_ONE_SYMPTOM_TO_REPORT)
            const jump = response.filter(c => c.name === UIconfigNames.JUMP_DIRECTLY_TO_OBSERVATIONS)
            const disclaimer = response.filter(c => c.name === UIconfigNames.SHOW_NEW_FAULT_DISCLAIMER)
            this.setState({
                UIconfig_ALLOW_JUST_ONE_SYMPTOM_TO_REPORT: allowOne.length === 0 ? false : allowOne[0].status === 'ACTIVE',
                UIconfig_JUMP_DIRECTLY_TO_OBSERVATIONS: jump.length === 0 ? false : jump[0].status === 'ACTIVE',
                UIconfig_SHOW_NEW_FAULT_DISCLAIMER: disclaimer.length === 0 ? false : disclaimer[0].status === 'ACTIVE',
            })
        })
    }

    fetchAssets(assetId) {
        const {userProfile} = this.props

        this.setState({loading: true})

        if (userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)) {
            this.state.apiPoint.fetchAssets(ASSETS_DATA_SET_TYPE.SHALLOW).then(response => {
                this.setState({
                    hierarchy: response,
                    loading: false,
                })
                if (assetId) {
                    this.loadObservations(assetId)
                }
            }).catch(ex => {
                verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
            })
        } else {
            Fleets.fetchHierarchy(true).then(response => {
                    this.setState({
                        hierarchy: response,
                        loading: false,
                    })
                    if (assetId) {
                        this.loadObservations(assetId)
                    }
                }
            )
        }
    }

    assetCreated(asset) {
        this.fetchAssets(asset.id)
    }

    getObservationsOptions(observations) {
        return observations.map(
            o => {
                return {value: o.id, text: this.setDescription(o.description, o.state), disabled: o.state === SYMPTOM_STATES.PRESENT}
            }
        )
    }

    setDescription(text, state) {
        return state === SYMPTOM_STATES.PRESENT ? text +  this.alreadyAssigned : text;
    }

    resetReport() {
        this.setState({
            ...this.initState,
            hierarchy: this.state.hierarchy,
        });
    }

    loadObservations(assetId) {
        const {userProfile} = this.props
        this.setState({
            selectedAssetId: assetId,
            selectedObservations: null,
            observations: [],
            loading: true,
        })
        if (userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)) {
            this.state.apiPoint.fetchAsset(assetId).then((response) => {
                    if (response.variants.length > 0) {
                        this.setState({ldiName: response.variants[0].ldiName})
                    } else {
                        showNotification({
                            translationPropertyKey: 'admin.asset.notification.noVariantConfiguration',
                            severity: "critical",
                        });
                    }
                }
            ).catch(ex => {
                verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
            })
        }
        this.state.apiPoint.fetchAssetObservation(assetId,[], [SYMPTOM_TYPES.REPORTED_SYMPTOM, SYMPTOM_TYPES.OBSERVATIONS_TYPE, SYMPTOM_TYPES.HEALTH_INDICATOR_TYPE]).then(
            response => this.setState({observations: response,
                loading: false})
        ).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        });
    }

    addObservation(ids) {
        // If user can enter only one symptom then we don't need to call for possibleFailureModes and symptoms.
        if (this.state.UIconfig_ALLOW_JUST_ONE_SYMPTOM_TO_REPORT || this.state.apiPoint === Airtime) {
            this.setState({selectedObservations: ids, disableSubmit : ids.length === 0})
            return;
        }
        // Empty selection. No api should be called.
        if (ids.length === 0) {
            this.setState({selectedObservations: ids, symptomsOfInterest: [], disableSubmit : ids.length === 0})
            return;
        }
        const submitFunction = this.state.UIconfig_JUMP_DIRECTLY_TO_OBSERVATIONS ? this.submitReportForHda : this.submitReport;

        // If we have enough symptoms to get only one failure mode we create fault
        this.state.apiPoint.fetchPossibleFailureModes(this.state.selectedAssetId, ids)
            .then(failureModes => {
                this.setState({
                    selectedObservations: ids,
                    disableSubmit: ids.length === 0,
                    symptomsOfInterest: []
                }, () => {
                    if (failureModes.length === 1) {
                        submitFunction(false, true);
                        return;
                    }
                    // We didn't have enough symptoms, so we fetch rest of the related symptoms
                    this.state.apiPoint.fetchAssetObservation(this.state.selectedAssetId, [], [], ids)
                        .then(observations => {
                            this.setState({
                                symptomsOfInterest: observations,
                            },  () => {
                                // We cannot further specify failure mode, so we create fault with provided symptoms
                                if (observations.filter(o => o.state !== 'PRESENT').length === ids.length) {
                                    submitFunction(false, false);
                                }
                            })
                        })
                })
            })
    }

    submitReport(buttonClicked, isUniqueFM) {
        const observations = this.state.selectedObservations.map(id => {
            return {id: id, state: "PRESENT"}
        });
        this.setState({loading: true})
        this.state.apiPoint.submitAssetObservations(this.state.selectedAssetId, observations).then(response => {
            this.resetReport()
            this.setState({
                affectedFaults: response,
                loading: false,
                submittedAutomatically: !buttonClicked,
                failureModeIdentified: isUniqueFM,
            })
        }).catch(ex => {
            if (ex.errorKey === 'business.exception.FAULT_CONDITION_STATE_TRANSITION_REJECTED') {
                this.resetReport();
                this.setState({
                    loading: false
                })
                showNotification({
                    translationPropertyKey: "fault.report.creation.symptom.error",
                    severity: "critical",
                });
            } else{
                verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
            }
        });
    }

    /**
     * This function work with only ONE selected symptom
     */
    submitReportForHda() {
        const {history, userProfile} = this.props
        const external = userHasActivity(userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)
        const observation = {id: this.state.selectedObservations, state: "PRESENT"};
        this.setState({loading: true})
        this.state.apiPoint.submitAssetObservations(this.state.selectedAssetId, [observation]).then(response => {
            if (response.length === 1 && response[0].faultConditionState === FAULT_STATES.NEW) {
                this.props.FaultActions.setFaultState(this.state.selectedAssetId, response[0].id, FAULT_STATES.IN_PROGRESS, [], null, external).then(() => {
                        external ?
                            history.push(`/airtime/asset/${this.state.selectedAssetId}/faults/${response[0].id}/troubleshooting`)
                            :
                            history.push(`/assets/${this.state.selectedAssetId}/faults/${response[0].id}/troubleshooting`)
                    }
                ).catch(ex => {
                    verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
                })
            } else {
                this.resetReport()
                this.setState({
                    affectedFaults: response,
                    loading: false,
                })
            }
        }).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        });
    }

    getSuccessNotification() {
        if (this.state.affectedFaults.length === 0) {
            return null
        }
        const { intl } = this.props
        const asset = this.state.affectedFaults[0].asset

        let automaticMessage = ""
        if (this.state.failureModeIdentified !== null) {
            automaticMessage = this.state.failureModeIdentified
                ? <div className='auto-message'>{intl.formatMessage({id: "fault.report.submit.auto.enoughSymptoms"})}</div>
                : <div className='auto-message'>{intl.formatMessage({id: "fault.report.submit.auto.noSymptoms"})}</div>
        }

        return <Notification
            hasIcon={true}
            severity="success"
            onCloseClick={() => this.setState({affectedFaults: []})}>

            <FormattedMessage id="fault.report.submit.success"/>
            {this.state.submittedAutomatically ? automaticMessage : " "}
            <FormattedMessage id="fault.report.submit.following.faults"/>

            <ul>
                {this.state.affectedFaults.map(f => <li key={f.id} className={'state-' + f.faultConditionState}>
                    <div className='state-icon'/>
                    <div className='state-name'><FormattedMessage id={"fault.detail.state." + f.faultConditionState}/>
                    </div>
                    <Link to={`/assets/${asset.id}/faults/${f.id}`}><Button
                        type="link">{getFaultName(f)}</Button></Link></li>)}
                <li className="asset-link"><Link to={`/assets/${asset.id}`}><Button type="link"><FormattedMessage
                    id={"fault.report.asset.faults"} values={{name: asset.name}}/></Button></Link></li>
            </ul>
        </Notification>
    }

    /**
     * Renders a symptom selector. If UI allows only one symptom to report then it renders select with param multiple
     * as false. Otherwise, we are able to select more symptoms and if there are already some selected observations we
     * get symptoms that are connected to those already selected first, and then we join them with the rest.
     */
    getSelector() {
        const { intl } = this.props
        const disableObservations = !this.state.selectedAssetId;
        let observationsOptions = this.getObservationsOptions(this.state.observations);

        if (this.state.selectedObservations && !this.state.UIconfig_ALLOW_JUST_ONE_SYMPTOM_TO_REPORT) {
            const symptomsOfInterest = this.getObservationsOptions(this.state.symptomsOfInterest)
            if (symptomsOfInterest.length !== 0) {
                observationsOptions = symptomsOfInterest
            }
        }

        return (
            <Select label={intl.formatMessage({id: "fault.report.symptom"})}
                        placeholder={intl.formatMessage({id: "fault.report.selectSymptom"})}
                        options={observationsOptions}
                        value={this.state.selectedObservations}
                        multiple={!this.state.UIconfig_ALLOW_JUST_ONE_SYMPTOM_TO_REPORT}
                        search={!disableObservations}
                        fluid
                        disabled={disableObservations}
                        onChange={(data) => (this.addObservation(data))}
            />
        )
    }

    getButton() {
        const { intl } = this.props
        return (
            <Button type="primary"
                    content={intl.formatMessage({id: "fault.report.submit"})}
                    disabled={this.state.disableSubmit}
                    onClick={(event, data) => (
                        this.state.UIconfig_JUMP_DIRECTLY_TO_OBSERVATIONS ?
                            this.submitReportForHda() : this.submitReport(true, null)
                    )}
                    className="mobile-max-width-button"
            />
        )
    }

    render() {
        const {intl, userProfile} = this.props

        const selector = this.getSelector();
        const button = this.getButton();

        return (
            <div id="fault-report-panel">
                <DisclaimerWindow
                    active={this.state.UIconfig_SHOW_NEW_FAULT_DISCLAIMER && !this.props.userProfile.disclaimerAccepted}
                    onAccept={this.props.SecurityActions.acceptDisclaimer}/>
                <Grid>
                    <Grid.Row>
                        {this.state.ldiName !== '' && userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) ?
                            <Grid.Column className="computer-only" width={2} sWidth={12}>
                                <div>
                                    <img alt="engine" className="engine-picture" src={this.state.ldiName.includes("HTF7K") ? engineHTF7K : engineTFE731}/>
                                    <FormattedHTMLMessage id={this.state.ldiName.includes("HTF7K") ? "HTF7K" : "TFE731"}/>
                                </div>
                            </Grid.Column>
                            :
                            <Grid.Column className="computer-only" width={2}/>
                        }
                        <Grid.Column className="computer-only" width={8}>
                            <Grid.Row>
                                <Grid.Column width={12}>
                                    {this.getSuccessNotification()}
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={12}>
                                    <div>
                                        <h2 className="fault-report-header">
                                            <FormattedMessage id="page.faultNew" />
                                        </h2>
                                        <div className="right">
                                            {button}
                                        </div>
                                    </div>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={12}>
                                    <div className="form-field">
                                        <InputLabel label={intl.formatMessage({id:"fault.report.asset"})}/>
                                        <AssetTreeSelector
                                            selectionChanged={(id) => {
                                                if (id.length > 0) {
                                                    this.loadObservations(id[0])
                                                } else {
                                                    this.setState({selectedAssetId: null})
                                                }
                                            }}
                                            selectedItems={this.state.selectedAssetId ? [this.state.selectedAssetId] : []}
                                            hierarchy={this.state.hierarchy}
                                            assetCreated={this.assetCreated}
                                            hdaUser={userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)}
                                        />
                                    </div>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={12}>
                                    <div className="form-field">
                                        {selector}
                                    </div>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={12}>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid.Column>
                        <Grid.Column className="mobile-only" width={12}>
                            <Grid.Row>
                                <Grid.Column width={12}>
                                    {this.getSuccessNotification()}
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={12}>
                                    <div>
                                        <h2 className="fault-report-header">
                                            <FormattedMessage id="page.faultNew" />
                                        </h2>
                                        <div className="right">
                                            {button}
                                        </div>
                                    </div>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={12}>
                                    <div className="form-field">
                                        <InputLabel label={intl.formatMessage({id:"fault.report.asset"})}/>
                                        <AssetTreeSelector
                                            selectionChanged={(id) => {
                                                if (id.length > 0) {
                                                    this.loadObservations(id[0])
                                                } else {
                                                    this.setState({selectedAssetId: null})
                                                }
                                            }}
                                            selectedItems={this.state.selectedAssetId ? [this.state.selectedAssetId] : []}
                                            hierarchy={this.state.hierarchy}
                                            assetCreated={this.assetCreated}
                                            hdaUser={userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)}
                                        />
                                    </div>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={12}>
                                    <div className="form-field">
                                        {selector}
                                    </div>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={12}>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Loader loading={this.state.loading}/>
            </div>
        )

    }

}

const mapStateToProps = (state) => {
    return {
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FaultActions: bindActionCreators(FaultActions, dispatch),
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(FaultReport)))